# Mandate 

TorontoJS is a not-for-profit corporation with a mandate to support all in their learning and passion for sharing knowledge on JavaScript and software development in Toronto and GTA.

# Mission

To facilitate events, connect people, share knowledge and shepard projects in order to build an open and accessible ecosystem. 
